import { defineStore } from "pinia";
import axios from "@/utils/axios";
import { useSharedStore } from "@/stores/shared-store";
import { useAuthStore } from "@/stores/auth-store";

export const useEnrollmentStore = defineStore("Enrollment", {
  state: () => ({
    enrollmentList: [],
    enrollmentStudent: [],
    enrollmentForm: {
      studentID: null,
      courseID_id: null,
      expiredAt: null,
      progress: 0.0,
      status: "Ongoing",
    },
    enrollmentStatusList: [],
    enrollmentDetail: null,

    filterGroup: [],
    filterDifficulties: [],
    filterInstructor: [],
    filterStatus: [],
  }),
  getters: {
    getTotalInProgressByCourse: (state) => (courseID) => {
      return state.enrollmentList.filter(
        (item) =>
          item.courseID.course_id === courseID && item.status === "Ongoing"
      ).length;
    },
    getTotalCompletedByCourse: (state) => (courseID) => {
      return state.enrollmentList.filter(
        (item) =>
          item.courseID.course_id === courseID && item.status === "Completed"
      ).length;
    },
    filteredEnrollmentCourses: (state) => {
      return state.enrollmentStudent.filter((item, index, self) => {
        const course = item.courseID;

        if (!course) return false;

        // Hindari duplikat berdasarkan course_id
        const isUnique =
          self.findIndex(
            (c) => c.courseID && c.courseID.course_id === course.course_id
          ) === index;

        if (!isUnique) return false;

        const matchInstructor =
          state.filterInstructor.length === 0 ||
          state.filterInstructor.includes(course.instructor);

        const matchGroup =
          state.filterGroup.length === 0 ||
          state.filterGroup.includes(course.course_group?.id);

        const matchDifficulty =
          state.filterDifficulties.length === 0 ||
          state.filterDifficulties.includes(course.level);

        const matchStatus =
          state.filterStatus.length === 0 ||
          state.filterStatus.includes(item.status);

        return matchInstructor && matchGroup && matchDifficulty && matchStatus;
      });
    },
  },
  actions: {
    async fetchEnrollmentList() {
      const sharedStore = useSharedStore();
      const authStore = useAuthStore();

      sharedStore.startRequest();
      try {
        const response = await axios.get(
          `${authStore.Url}/api/class-access/enrollments`
        );
        this.enrollmentList = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        sharedStore.endRequest();
      }
    },
    async fetchEnrollmentStatusList() {
      const sharedStore = useSharedStore();
      const authStore = useAuthStore();

      sharedStore.startRequest();
      try {
        const response = await axios.get(
          `${authStore.Url}/api/class-access/enrollments/status-list`
        );
        this.enrollmentStudent = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        sharedStore.endRequest();
      }
    },
    async fetchEnrollmentStudentList(id) {
      const sharedStore = useSharedStore();
      const authStore = useAuthStore();

      sharedStore.startRequest();
      try {
        const response = await axios.get(
          `${authStore.Url}/api/class-access/enrollments/?studentID=${id}`,
        );
        this.enrollmentStudent = response.data;
      } catch (error) {
        console.error("Gagal mengambil data enrollment.", error);

        console.log(error);
      } finally {
        sharedStore.endRequest();
      }
    },

    async submitEnrollment() {
      const sharedStore = useSharedStore();
      const authStore = useAuthStore();

      sharedStore.startRequest();
      try {
        const response = await axios.post(
          `${authStore.Url}/api/class-access/enrollments/`,
          this.enrollmentForm
        );

        sharedStore.showSuccess("Enrollment berhasil dibuat.");
        return response.data;
      } catch (error) {
        console.error("Gagal submit enrollment:", error);
        sharedStore.showError("Gagal membuat enrollment.", error);
        throw error;
      } finally {
        sharedStore.endRequest();
      }
    },
    clearAllFilters() {
      this.filterGroup = [];
      this.filterDifficulties = [];
      this.filterInstructor = [];
      this.filterStatus = [];
    },
    async fetchEnrollmentDetail(enrollmentId) {
      const sharedStore = useSharedStore();
      const authStore = useAuthStore();

      sharedStore.startRequest();
      try {
        const response = await axios.get(
          `${authStore.Url}/api/class-access/enrollments/${enrollmentId}`,
        );
        this.enrollmentDetail = response.data;
      } catch (error) {
        console.error("Gagal mengambil data enrollment.", error);

        console.log(error);
      } finally {
        sharedStore.endRequest();
      }
    },
  },
});
